import React, { useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Form, Upload, Space, Button, message } from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { Col } from "antd";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as User } from "../../../image/User.svg";
import { patchRequest } from "../../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import Dragger from "antd/lib/upload/Dragger";

const RequestedStatusProposal = ({
  handleCancel,
  userId,
  changeCurrentStatus,
  setReload,
  reload,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [uploadFile, setUploadFile] = useState(null);
  // const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [size, setSize] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const backToList = () => {
    handleDeleteFile();
    handleCancel();
  };
  // const url = state.image;

  // let filename = "";
  // try {
  //   if (fileLink) {
  //     filename = url.split("/").pop();
  //   }
  // } catch (e) {
  //   filename = "";
  // }
  const handleDeleteFile = () => {
    setUploadFile(null); // Clear the uploaded file
    setFileName(null); // Clear the file name
    setSize(null);
  };
  const uploadProps = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        setErrorMsg("You can only upload JPG/PNG file!");
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {
        setSize(file.size);
        if (file.size <= 2097152) {
          setUploadFile(file);
          setFileName(file.name);
        }
        setErrorMsg("");
      }
      // Clear error message if file type is correct
      return false;
    },
  };

  // const handleDelete = () => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     proposal_sent_attachment: null,
  //   }));
  //   setUploadFile("");
  //   setFileName(null);
  //   setSize(null);
  // };

  // const handleFileDelete = async () => {
  //   // const apiResponse = await deleteRequest(
  //   //   `material-master-image-delete/${MaterialId}/`
  //   // );
  //   // if (apiResponse.data.success) {
  //   //   SuccessNotificationMsg(t("image_deleted_success"));
  //   //   setFileLink(null);
  //   //   setFileName(null);
  //   //   setSize(null);
  //   // }
  // };

  const handleSubmit = async () => {
    if (!uploadFile) {
      // Prevent form submission if no document is uploaded
      ErrorNotificationMsg(t("val_document_upload"));
      return;
    }
    setBtnLoading(true);

    try {
      let apiResponse;

      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();
      formData.append("proposal_sent_attachment", uploadFile);
      formData.append("status", changeCurrentStatus);
      apiResponse = await patchRequest(
        `request-demo-status/${userId}/`,
        formData,
        customerHeaders
      );

      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("status_changed_successfully"));
        setBtnLoading(false);
        handleDeleteFile();
        handleCancel();
        setReload(!reload);
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_changing_status"));
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div>
        <Form
          className="ModalForm"
          autoComplete="off"
          onFinish={handleSubmit}
          ref={formRef}
        >
          <Col span={48} className="TextField">
            <Form.Item
              className="BrowsButtonSecDemo"
              name="proposal_sent_attachment"
              // label={t("label_upload_proposal")}
              prefix={<User />}
              rules={[
                {
                  required: false,
                  message: <Trans>{t("val_document_upload")}</Trans>,
                },
              ]}
            >
              <Dragger
                placeholder="test"
                className="BrowsButton"
                {...uploadProps}
                // beforeUpload={beforeUpload}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                {/* <Button icon={<UploadOutlined />}> */}
                {/* {t("upload_image")} */}
                {/* </Button> */}
                <div className="condition">
                  {" "}
                  <p
                    style={{
                      color: size > 2097152 ? "red" : "GrayText",
                    }}
                  >
                    {t("upload_fileSize")} {t("upload_imagefileType")}
                  </p>
                </div>
              </Dragger>
              {size <= 5242880 && (
                <>
                  <Space className="uploadedfile" size={[12, 16]}>
                    <a
                      href={fileName}
                      className="link-color"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {/* {fileLink ? filename : fileName} */}
                      {fileName}
                    </a>
                    {/* {fileLink && <DeleteOutlined onClick={handleFileDelete} />} */}
                    {fileName && <DeleteOutlined onClick={handleDeleteFile} />}
                  </Space>
                </>
              )}
            </Form.Item>
          </Col>

          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </div>
    </>
  );
};

RequestedStatusProposal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  userId: PropTypes.number,
  changeCurrentStatus: PropTypes.string,
  setReload: PropTypes.func.isRequired,
  reload: PropTypes.bool,
};

export default RequestedStatusProposal;
